import { useDataLoaderHooks } from './use-dataloader-hooks'
import { UseFavorites } from '@dustin-web/microsite-data/src/hooks/use-favorites-internal'
export type { FavoriteProductList } from '@dustin-web/microsite-data/src/hooks/use-favorites-internal'

export const useFavorites: UseFavorites = () => {
  const { favorites } = useDataLoaderHooks()

  return (
    favorites() || {
      data: null,
      error: null,
      loading: true,
      updateFavorites: () => {},
      favoritesLists: [],
    }
  )
}
